module.exports = __webpack_public_path__ + "static/media/untitled2.103f4675.jpg";